import router from '@/router'
import Notification from '@/services/notification'
import i18n from '@/helpers/i18n'

import { decodeJwt } from '@/helpers/jwt'
import { VUE_APP_ROOT_API } from '@/helpers/env'
import StatusHelper from '@/helpers/status'

import UserService from '@/services/user'
import WebisteService from '@/services/website'
import SnipcartService from '@/services/snipcart'

import { URL_ROOT } from '@/consts/urls'
import { USER_TYPE_USER, USER_TYPE_ADMIN, USER_TYPE_ANONYME } from '@/consts/enums'
import { CLAIM_UTYPE_USER, CLAIM_UTYPE_SYSTEMADMIN } from '@/consts/claims'
import { LOCAL_STORAGE_AUTHTOKEN, LOCAL_STORAGE_REFRESHTOKEN, LOCAL_STORAGE_RENEWTOKEN_STATUS } from '@/consts/local-storage'

export default {
  login: async function(username, password, loginResolver = null) {
    const response = await fetch(`${VUE_APP_ROOT_API}/loginapi/login`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ username, password })
    })

    if (StatusHelper.isSuccess(response.status)) {
      const result = await response.json()
      await setUser(result.Token, result.RefreshToken)
      WebisteService.setHeaderLogedIn()
      SnipcartService.updateCartUserId()

      if (loginResolver !== null && typeof loginResolver === 'function') {
        loginResolver()
      } else {
        router.push(
          router.currentRoute.query.returnPath || {
            name: URL_ROOT,
            query: {
              isFromFeaturedProduct: router.currentRoute.query.isFromFeaturedProduct
            }
          }
        )
      }
    } else if (response.status === 400) {
      Notification.showWarning(i18n.t('email-notconfirmed'))
    } else if (response.status === 401) {
      Notification.showError(i18n.t('error-login-email-password'))
    } else {
      Notification.showError(i18n.t('error-basic'))
    }
  },
  renewToken: async function() {
    if (localStorage.getItem(LOCAL_STORAGE_RENEWTOKEN_STATUS)) {
      await waitRefreshToken()
      return
    }

    localStorage.setItem(LOCAL_STORAGE_RENEWTOKEN_STATUS, 'active')

    const response = await fetch(`${VUE_APP_ROOT_API}/loginapi/refresh`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ refreshToken: UserService.getRefreshToken() })
    })

    if (StatusHelper.isSuccess(response.status)) {
      let result = await response.json()
      await setUser(result.Token, result.RefreshToken)
    } else {
      await logout()
      return false
    }

    localStorage.removeItem(LOCAL_STORAGE_RENEWTOKEN_STATUS)
    return true
  },
  logout: logout,
  loadLocalState: async function() {
    let token = localStorage.getItem(LOCAL_STORAGE_AUTHTOKEN)
    let refreshToken = localStorage.getItem(LOCAL_STORAGE_REFRESHTOKEN)
    localStorage.removeItem(LOCAL_STORAGE_RENEWTOKEN_STATUS)

    if (token !== null && token !== undefined && refreshToken !== null && refreshToken !== undefined) {
      await setUser(token, refreshToken)
    }
  },
  getUserIsLogged() {
    return UserService.isConnected()
  },
  getUserType: function() {
    if (!UserService.isConnected()) return USER_TYPE_ANONYME

    const token = this.getUserToken()
    const { type } = decodeJwt(token)

    switch (type) {
      case CLAIM_UTYPE_USER:
        return USER_TYPE_USER
      case CLAIM_UTYPE_SYSTEMADMIN:
        return USER_TYPE_ADMIN
      default:
        return type
    }
  },
  getUserToken: function() {
    return UserService.getAccessToken()
  },
  getUserRefreshToken: function() {
    return UserService.getRefreshToken()
  }
}

async function setUser(accessToken, refreshToken) {
  localStorage.setItem(LOCAL_STORAGE_AUTHTOKEN, accessToken)
  localStorage.setItem(LOCAL_STORAGE_REFRESHTOKEN, refreshToken)

  let userToken = decodeJwt(accessToken)

  await UserService.setLocalUser(
    true, // isConnected
    userToken.type,
    accessToken,
    refreshToken
  )
}

async function waitRefreshToken() {
  return new Promise((resolve, reject) => {
    let timerId = setInterval(function() {
      if (!localStorage.getItem(LOCAL_STORAGE_RENEWTOKEN_STATUS)) {
        clearInterval(timerId)
        resolve()
      }
    }, 50)
  })
}

async function logout() {
  localStorage.removeItem(LOCAL_STORAGE_AUTHTOKEN)
  localStorage.removeItem(LOCAL_STORAGE_REFRESHTOKEN)
  WebisteService.setHeaderLogedOut()
  await SnipcartService.removeBusinessFromCart()
  await SnipcartService.updateCartUserId()
  await UserService.setLocalUser(false, null, null, null)
  window.location.href = `${router.options.base}/tableau-de-bord/connexion${window.location.search}`
}
